<template>
	<div>
		<el-row style="border-bottom: 1px solid #ebeef5;padding-bottom: 20px;background-color: blue;width: 1350px">
			<el-col :span="4"></el-col>
			<el-col :span="14" style="text-align: center;">
				<div style="font-size: 30px; font-weight: bold;vertical-align: center;color: white">中级消防设施操作员[实操题]练习
					{{ paperInfo.name }}
				</div>
				<div style="font-size: 16px; color: gray;vertical-align: center;color: white">
					题目类型:{{ paperDetailInfo.name }}
					第{{ questionNumber }}题/共{{ paperDetailInfo.totalCount }}题
					答题时间:{{ paperDetailInfo.limitTime }}分钟
				</div>
			</el-col>
			<el-col :span="6">
				<el-menu mode="horizontal">
					<el-sub-menu index="1">
						<template #title>
							<div style="font-size: 20px;border-bottom-color: transparent;">欢迎 {{ loginNickName }}</div>
						</template>
						<el-menu-item @click="handleToPage('/')" index="home">首页</el-menu-item>
						<el-menu-item v-if="!isBuy"
							@click="handleToTryPractice('/fire/try/practice/theoryMediumDevice','try', 'practice','theory')"
							index="theoryPracticeTry">理论练习</el-menu-item>
						<el-menu-item v-if="!isBuy"
							@click="handleToTryPractice('/fire/try/exam/theoryMediumDevice','try', 'exam','theory')"
							index="theoryExamTry">模拟理论考试</el-menu-item>
						<el-menu-item v-if="!isBuy"
							@click="handleToTryPractice('/fire/try/practice/peopleMediumDevice','try', 'practice','people')"
							index="peoplePracticeTry">人考题练习</el-menu-item>
						<el-menu-item v-if="!isBuy"
							@click="handleToTryPractice('/fire/try/exam/peopleMediumDevice','try', 'exam','people')"
							index="peoplePracticeTry">人考题考试</el-menu-item>
						<el-menu-item v-if="isBuy"
							@click="handleToTryPractice('/fire/normal/practice/theoryMediumDevice','normal', 'practice','theory')"
							index="theoryPractice">理论练习</el-menu-item>
						<el-menu-item v-if="isBuy"
							@click="handleToTryPractice('/fire/normal/exam/theoryMediumDevice','normal', 'exam','theory')"
							index="theoryExam">模拟理论考试</el-menu-item>
						<el-menu-item v-if="isBuy"
							@click="handleToTryPractice('/fire/normal/practice/peopleMediumDevice','normal', 'practice','people')"
							index="peoplePractice">实操题练习</el-menu-item>
						<el-menu-item v-if="isBuy"
							@click="handleToTryPractice('/fire/normal/exam/peopleMediumDevice','normal', 'exam','people')"
							index="peopleExam">实操题考试</el-menu-item>
					</el-sub-menu>
				</el-menu>
			</el-col>
		</el-row>

		<div :style="{ backgroundImage: `url(${this.backgroundImg})`}" class="room-div">
			<div>
				<audio ref="questionAudioPlayer" autoplay></audio>
			</div>

			<div class="div-pre-modify-bordered-item"
				v-for="(preModifyItem, index) in paperContentInfo.questionPreModifyDtoList"
				:style=preModifyItem.divStyle :key="index">

				<img v-if="preModifyItem.imageStyle!== null" :style=preModifyItem.imageStyle
					:src="`/view/FireEngine/picture${preModifyItem.imagePath}`" alt="light">

				<!--        <div>-->
				<!--          <el-image :src=require("@/assets/picture/FireEngine"+preModifyItem.imagPath)></el-image>-->
				<!--        </div>-->
				<div v-if="preModifyItem.text!== null" :style="preModifyItem.textStyle">{{preModifyItem.text}}</div>
				<img v-show="preModifyItem.gifStyle!== null &&showGif===true" :style=preModifyItem.gifStyle
					:src="`/view/FireEngine/picture${preModifyItem.imagePath}`" alt="gif" @load="closeGif">
				<!--        <audio v-if="preModifyItem.audioStyle!==null" ref="preModifyAudioPlayer" autoplay></audio>-->

			</div>

			<div class="div-operation-bordered-item"
				v-for="(operationItem, index) in paperContentInfo.questionOperationDtoList"
				:style=operationItem.divStyle :key="index" @click="operationClick(operationItem)"
           @contextmenu.prevent="handleRightClick($event, operationItem)">

				<img v-if="operationItem.imageStyle!== null" :style=operationItem.imageStyle
					:src="`/view/FireEngine/picture${operationItem.imagePath}`" alt="opt">
				<audio v-if="operationItem.audioStyle!==null" ref="operationAudioPlayer" autoplay></audio>
				<!--        <div>-->
				<!--          <el-image :src=require("@/assets/picture/FireEngine"+preModifyItem.imagPath)></el-image>-->
				<!--        </div>-->

			</div>

			<div class="div-recognize-bordered-item"
				v-for="(recognizeItem, index) in paperContentInfo.questionRecognizeDtoList" :style="recognizeItem.style"
				:key="index" :class="{ 'div-recognize-selected': selectedRecognizeItem.includes(recognizeItem) }"
				@click="selectMultiBoxAsAnswer(recognizeItem)">

				<!--      <div class="div-recognize-bordered-item" style="width: 150px;height: 50px;top: 38%; left: 67.5%"-->
				<!--      @click="selectBoxAsAnswer(1)" :class="{ 'selected': selectedItem === id }">-->

			</div>

			<el-dialog v-model="isRecording" title="开始答题" append-to-body style="width: 320px">
				<recordComponent @submitRecord:value="submitRecording"></recordComponent>
			</el-dialog>
			<!--      <el-dialog v-model="isCountScore" title="计算得分" append-to-body style="width: 320px">-->
			<!--        <p>正在计算得分</p>-->
			<!--      </el-dialog>-->
			<div class="draggable">
				{{ questionNumber }}.{{paperContentInfo.question}}({{paperContentInfo.label}})
				<img style="width: 20px;height: 20px" src="@/assets/picture/sound.png" alt="sound"
					@click="playQuestionAudio">
				<div v-if="paperContentInfo.type==='recognize'||paperContentInfo.type==='operation'"
					style="background-color: lightgray;border-bottom-left-radius:10px;border-bottom-right-radius:10px;width:250px">
					<el-radio-group v-for="(answerInfo,index) in paperContentInfo.questionAnswerDtoList" :key="index"
						v-model="userAnswer"
						style="display: flex; flex-direction: column; align-items: flex-start;margin-left: 5px;margin-top: 20px">
						<el-radio :label="answerInfo.alphabet" @click="getCurrentChoice(answerInfo)">
							{{ answerInfo.alphabet }}.{{ answerInfo.content }}&nbsp;&nbsp;
						</el-radio>
					</el-radio-group>
				</div>
				<div v-if="paperContentInfo.type==='oral'" style="display: flex;flex-wrap: wrap; ">
					<el-checkbox-group style="margin-right: 10px;" v-model="selectedAnswers">
						<el-checkbox :label="answerInfo" :value="answerInfo"
							v-for="answerInfo in paperContentInfo.questionAnswerDtoList" :key="answerInfo.id">
							{{ answerInfo.alphabet }}.{{ answerInfo.content }}
						</el-checkbox>
					</el-checkbox-group>
				</div>
			</div>
			<div style="position: fixed;top: 95%;width: 100%;">
				<el-button type="danger" style="margin-left: 20px" @click="getAnalysis()">解析</el-button>
				<el-button type="warning" v-if="paperContentInfo.type==='oral'" style="margin-left: 20px"
					@click="showCounting">得分</el-button>
				<el-button type="primary" v-if="questionNumber>1" style="margin-left: 20px"
					@click="getPreviousQuestion()">上一题</el-button>
				<el-button type="primary" v-if="questionNumber<paperDetailInfo.totalCount" style="margin-left: 20px"
					@click="getNextQuestion()">下一题</el-button>


				<el-button type="primary" style="float:right;margin-right: 20px" @click="goBack()">返回</el-button>
				<el-button type="info" style="float:right;margin-right: 20px" v-if="paperInfo.status === 'active'"
					@click="feedBack()">反馈</el-button>
				<el-button type="warning" style="float:right;margin-right: 20px"
					@click="getCurrentQuestion()">重做</el-button>
				<el-button type="primary" v-if="paperContentInfo.type==='oral' && currentStepId === totalStepCount"
					style="float:right;margin-right: 20px" @click="startRecording">语音答题</el-button>
				<el-button type="primary" v-if="currentStepId>=totalStepCount && paperContentInfo.type!=='oral'"
					style="float:right;margin-right: 20px" @click="submitAnswer()">提交</el-button>
				<!--        <el-button type="primary" v-if="currentStepId<totalStepCount" style="float:right;margin-right: 20px">下一步</el-button>-->
				<audio ref="answerPlayer" autoplay></audio>
			</div>

			<el-dialog v-model="isCountScore" title="得分" append-to-body>
				<el-table :data="userOralAnswer">
					<el-table-column prop="questionName" label="问题" width="180">
					</el-table-column>
					<el-table-column prop="score" label="得分(百分比)">
					</el-table-column>
					<el-table-column label="说明">
						<template #default="{ row }">
							<div v-if="row.status==='success'||row.status==='failure'">
								<el-button type="warning" v-if="row.score <60 " @click="reAnswer(row)">重新答题</el-button>
								<text v-if="row.score>=60&& row.score<80">回答基本正确</text>
								<text v-if="row.score>=80">回答正确</text>
							</div>

							<div v-if="row.status!=='success' && row.status!=='failure'">
								<text>计算中</text>
							</div>

						</template>
					</el-table-column>
				</el-table>
			</el-dialog>
			<el-dialog v-model="showFeedBack" title="反馈" append-to-body>
				<feedBackComponent :questionId="questionId" :areaId="areaId" :paperId="paperId"
					:questionType="questionType" @submitFeedBack:value="handleFeedBackDialog"></feedBackComponent>
			</el-dialog>
			<el-dialog v-model="showAnalysis" title="解析" append-to-body style="overflow:auto;">
				<div class="dialogBody">
					<el-card class="el-card-class" v-if="paperContentInfo.type==='oral' && hasSelfAnswer">
						用户自定义答案<el-tooltip content="请确保提供的答案正确，模拟考试时会以此答案来判分" placement="top">
							<el-icon>
								<QuestionFilled></QuestionFilled>
							</el-icon>
						</el-tooltip>：
						<text style="white-space:pre-wrap"> {{userQuestionInfo.answerText}}</text>
						<!--            <audio ref="userDefinePlayer" :src="userDefinePlayerUrl" controls-->
						<!--                   @pause="userDefinePlayerPause" @play="userDefinePlay"></audio>-->

						<br>
						<el-button type="warning" @click="modifySelfAnswer" size="small"
							v-if="!showSelfAnswer ">修改</el-button>
						<el-button type="danger" @click="deleteSelfAnswer" size="small"
							v-if="!showSelfAnswer">删除</el-button>
					</el-card>
					<el-card class="el-card-class">参考答案
						<el-tooltip content="若参考答案与本地培训机构的不一致，请以培训机构的为准" placement="top">
							<el-icon>
								<QuestionFilled></QuestionFilled>
							</el-icon>
						</el-tooltip>：

						{{paperContentInfo.analysisText}}</el-card>

					<el-card style="color:red;" class="el-card-class"
						v-if="paperContentInfo.attention!==''&& paperContentInfo.attention!==null">注意点：{{paperContentInfo.attention}}</el-card>

					<el-card class="el-card-class"
						v-if="paperContentInfo.analysisVideo!==''&&paperContentInfo.analysisVideo!==null">
						分析视频
						<video width="600" height="300" controls :src="videoDetailPath">

						</video>
					</el-card>

					<el-card class="el-card-class"
						v-if="paperContentInfo.referenceVideo!==''&&paperContentInfo.referenceVideo!==null">
						实操视频
						<video width="600" height="300" controls :src="referenceVideoDetailPath">
							<!--              <source :src="require(`@/assets/video/FireEngine`+paperContentInfo.referenceVideo)" type="video/mp4">-->
							<!--              <source :src="referenceVideoDetailPath" type="video/mp4">-->
							<!--              Your browser does not support the video tag.-->
						</video>
					</el-card>

					<el-card v-if="showSelfAnswer">
						<el-input type="textarea" maxlength="100" v-model="userDefineAnswerContent"
							placeholder="请输入您的答案"></el-input>
						<!--            <el-form-item prop="userDefineAudio" label="语音答案">-->
						<!--              <audio ref="userDefinePlayer" :src="userDefinePlayerUrl" controls-->
						<!--                     @pause="userDefinePlayerPause" @play="userDefinePlay" v-if="hasUserDefineRecord"></audio>-->
						<!--              <el-button type="primary" size="small" @click="userDefineText2Audio" v-if="!hasUserDefineRecord">AI生成语音</el-button>-->
						<!--              <el-button size="small" type="primary" @click="userDefineAnswerAudio" v-if="!hasUserDefineRecord">点击录制-->
						<!--              </el-button>-->
						<!--              <el-upload style="margin-top: 10px;margin-left: 20px"-->
						<!--                         action="#"-->
						<!--                         :before-upload="beforeUserDefineAudioUpload"-->
						<!--                         :http-request="uploadUserDefineAudio"-->
						<!--                         v-if="!hasUserDefineRecord"-->
						<!--              >-->
						<!--                <el-button size="small" type="primary">点击上传</el-button>-->
						<!--              </el-upload>-->
						<!--              <el-button size="small" type="primary" @click="removeUserDefineAudio" v-if="hasUserDefineRecord">删除录音</el-button>-->
						<!--            </el-form-item>-->
					</el-card>
					<!--          <el-dialog v-model="showAnswerRecord" title="录音" append-to-body style="width: 320px">-->
					<!--            <recordComponent @submitRecord:value="handleAnswerRecordDialog"></recordComponent>-->
					<!--          </el-dialog>-->
					<!--        <video width="600" height="300" controls v-if="paperContentInfo.referenceVideo!==''&&paperContentInfo.referenceVideo!==null">-->
					<!--          考场参考回答-->
					<!--          <source :src="require(`@/assets/video/FireEngine`+paperContentInfo.referenceVideo)" type="video/mp4">-->
					<!--          Your browser does not support the video tag.-->
					<!--        </video>-->

				</div>
				<template #footer>
					<el-button type="warning" @click="defineSelfAnswer"
						v-if="paperContentInfo.type==='oral' && !showSelfAnswer && !hasSelfAnswer">添加自定义答案</el-button>
					<el-button type="warning" @click="submitSelfAnswer"
						v-if="paperContentInfo.type==='oral' && showSelfAnswer">提交自定义答案</el-button>
				</template>
			</el-dialog>
		</div>
	</div>


</template>

<script>
	import {
		useRoute
	} from "vue-router/dist/vue-router";
	import request from "@/utils/request";
	import {
		ElMessage,
		ElMessageBox
	} from "element-plus";
	import router from "@/router";
	import {
		ref
	} from "vue";
	import feedBackComponent from "@/components/FeedBack";
	import recordComponent from "@/components/Record";
	import {
		QuestionFilled
	} from "@element-plus/icons-vue";


	const loginNickName = localStorage.getItem("loginNickName");
	const loginUserId = localStorage.getItem("loginUserId");

	const questionNumber = ref(1);

	// const hasSelected = ref(false);

	const percentage = ref(0);
	const paperTotalCount = ref(0);
	const questionType = ref('');
	const isBuy = ref(false);
	const paperFontSize = ref('18px');
	const backgroundImg = ref('');
	// const soundPath=ref('');

	const currentStepId = ref(1);
	const totalStepCount = ref(1);

	const userDefinePlayer = ref(new Audio());
	const userDefinePlayerUrl = ref('');
	const userDefineAudio = ref('');

	const showAnswerRecord = ref(false);
	const hasUserDefineRecord = ref(false);

	let analysisVideoPath = '';
	const isCountScore = ref(false);

	if (process.env.NODE_ENV === "development") {
		analysisVideoPath = process.env.VUE_APP_ANALYSIS_VIDEO_PATH;
	} else {
		analysisVideoPath = process.env.VUE_APP_ANALYSIS_VIDEO_PATH;
	}

	function text2AudioAnswer() {
		request.post('/userFeedBackInfo/text2audio', {
				userId: loginUserId,
				answerText: userDefineAnswerContent.value,
				answerAudioPath: userDefinePlayerUrl.value,
			}, {
				headers: {
					'Content-Type': 'application/json;charset=utf-8'
				},
				responseType: 'blob'
			}).then(response => {
				if (response.status === 200) {
					const result = response.data; // 将接口返回的数据赋值给result
					const header = response.headers;
					const params = header["content-disposition"]
						.split(';')
						.map(param => param.trim())
						.reduce((acc, part) => {
							const [key, value] = part.split('=');
							acc[key] = value;
							return acc;
						}, {});
					userDefineAudio.value = params['fileName'];

					userDefinePlayerUrl.value = URL.createObjectURL(result);
				} else {
					router.push("/login");
				}
			})
			.catch(error => {
				console.log("feedback error:" + error);
				// ElMessage.error("系统异常，请联系管理员");
			});
	}

	async function deleteAudioFromServer(audioPath, type) {
		await request.delete(`/userFeedBackInfo/deleteAudio/${loginUserId}`, {
			data: {
				titleAudioPath: audioPath
			}
		}).then(response => {
			const result = response.data; // 将接口返回的数据赋值给result
			if (result.code === "200") {
				ElMessage.success("删除成功");
				if (type === "answer") {
					userDefineAudio.value = '';
				}
			} else {
				ElMessage.warning(result.msg);
			}
		}).catch(error => {
			console.log("uploadPicture error:" + error);
			// ElMessage.error("系统异常，请联系管理员");
		});
	}

	async function uploadUserDefineRecord(file, type) {
		const formData = new FormData();
		formData.append("file", file, Date.now() + ".mp3");
		formData.append("type", type);
		formData.append("userId", loginUserId);
		// formData.append("paperId",paperId);

		await request.post('/userFeedBackInfo/uploadAudio', formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		}).then(response => {
			const result = response.data; // 将接口返回的数据赋值给result
			if (result.code === "200") {
				if (type === "answer") {
					userDefineAudio.value = result.data;
					userDefinePlayerUrl.value = URL.createObjectURL(file);
				}
			} else {
				ElMessage.warning(result.msg);
			}
		}).catch(error => {
			console.log("uploadUserDefineRecord error:" + error);
			// ElMessage.error("系统异常，请联系管理员");
		});
	}

	function getPaperContentByUserQuestion(questionType, status) {
		request.get('/userQuestionInfo/paperContentInfo/one', {
				params: {
					userId: loginUserId,
					questionType: questionType,
					type: status,
					questionNumber: questionNumber.value
				}
			})
			.then(response => {
				const result = response.data; // 将接口返回的数据赋值给result
				if (result.code === "200") {
					paperContentInfo.value = result.data;
					getRelativeInfo("userQuestion");
				} else {
					ElMessage.warning(result.msg);
					if (result.msg === '认证失败,请重新登录') {
						router.push("/login")
					}
				}
			})
			.catch(error => {
				console.log("TheoryMediumDevice error:" + error);
				// ElMessage.error("系统异常，请联系管理员");
			});
	}

	function getPaperDetailInfoByQuestionId(questionType, status) {
		request.get('/userQuestionInfo/paperDetail', {
				params: {
					userId: loginUserId,
					questionType: questionType,
					type: status
				}
			})
			.then(response => {
				const result = response.data; // 将接口返回的数据赋值给result
				if (result.code === "200") {
					this.paperDetailInfo = result.data;
					paperTotalCount.value = this.paperDetailInfo.totalCount;
					if (paperTotalCount.value === 0) {
						if (status === 'error') {
							ElMessage.warning("您还没有生成此类型题目，错题在考试后自动生成")
						}
						if (status === 'collection') {
							ElMessage.warning("您还没有生成此类型题目，收藏题需手动添加")
						}
						if (status === 'userDefine') {
							ElMessage.warning("您还没有生成此类型题目，自定义题库需在反馈页面中增加新题")
						}
						this.goBack();
					}
				} else {
					ElMessage.warning(result.msg);
				}
			})
			.catch(error => {
				console.log("TheoryMediumDevice error:" + error);
				// ElMessage.error("系统异常，请联系管理员");
			});
	}

	async function getPaperDetailInfoByFeedBack(questionType) {
		await request.get('/feedBackInfo/paperDetail', {
				params: {
					userId: loginUserId,
					areaId: areaId.value,
					questionType: questionType
				}
			})
			.then(response => {
				const result = response.data; // 将接口返回的数据赋值给result
				if (result.code === "200") {
					this.paperDetailInfo = result.data;
					paperTotalCount.value = this.paperDetailInfo.totalCount;
					if (paperTotalCount.value === 0) {
						ElMessage.warning("您还没有生成此类型题目，反馈题在接受到反馈后自动生成")
						this.goBack();
					}
				} else {
					ElMessage.warning(result.msg);
				}
			})
			.catch(error => {
				console.log("paperDetailInfo error:" + error);
				// ElMessage.error("系统异常，请联系管理员");
			});
	}

	async function getPaperContentByFeedBack(questionType) {
		await request.get('/paperContentInfo/feedback/one', {
				params: {
					userId: loginUserId,
					questionNumber: questionNumber.value,
					questionType: questionType,
					areaId: areaId.value
				}
			})
			.then(response => {
				const result = response.data; // 将接口返回的数据赋值给result
				if (result.code === "200") {
					paperContentInfo.value = result.data;
					getRelativeInfo("feedback")
				} else {
					ElMessage.warning(result.msg);
				}
			})
			.catch(error => {
				console.log("TheoryMediumDevice error:" + error);
				// ElMessage.error("系统异常，请联系管理员");
			});
	}
	//
	// const videoUrl=ref('');
	// async function getVideo(path){
	//
	//   request.get("/fileSystem/video",
	//       {
	//         responseType: 'blob',
	//         params: {
	//           filePath:analysisVideoPath+path
	//         }
	//       }).then(response => {
	//     if (response.status === 200) {
	//       const result = response.data; // 将接口返回的数据赋值给result
	//
	//       videoUrl.value = URL.createObjectURL(result);
	//     } else {
	//       router.push("/login");
	//     }});
	// }

	function getPaperDetailInfoByRandomExam(questionType, status) {
		request.get('/paperDetailInfo/randomExam', {
				params: {
					userId: loginUserId,
					questionType: questionType,
					type: status
				}
			})
			.then(response => {
				const result = response.data; // 将接口返回的数据赋值给result
				if (result.code === "200") {
					this.paperDetailInfo = result.data;
					paperTotalCount.value = this.paperDetailInfo.totalCount;
				} else {
					ElMessage.warning(result.msg);
				}
			})
			.catch(error => {
				console.log("TheoryMediumDevice error:" + error);
				// ElMessage.error("系统异常，请联系管理员");
			});
	}

	async function getRelativeInfo(type) {
		questionId.value = paperContentInfo.value.id;
		questionTypePlayer.value.src = require("@/assets/sound/" + paperContentInfo.value.type + ".mp3");
		questionTypePlayer.value.play();
		if (paperContentInfo.value.imagePath !== '') {
			if (type === "userQuestion") {
				backgroundImg.value = 'view' + paperContentInfo.value.imagePath;
			} else {
				backgroundImg.value = 'view/FireEngine/picture' + paperContentInfo.value.imagePath;
			}
		}
		if (paperContentInfo.value.soundPath !== null && paperContentInfo.value.soundPath !== "") {
			if (type === "userQuestion") {
				questionAudioPlayer.value.src = 'view' + paperContentInfo.value.soundPath;
			} else {
				questionAudioPlayer.value.src = 'view/FireEngine' + paperContentInfo.value.soundPath;
			}
			setTimeout(() => {
				questionAudioPlayer.value.play()
			}, 2000);
		}
		if (paperContentInfo.value.questionOperationDtoList !== null && paperContentInfo.value.questionOperationDtoList
			.length > 0) {
			totalStepCount.value = paperContentInfo.value.questionOperationDtoList[0].totalStepCount;
		}
		if (paperContentInfo.value.label === 'require') {
			paperContentInfo.value.label = '必考题';
		}
		if (paperContentInfo.value.label === 'choose') {
			paperContentInfo.value.label = '抽考题';
		}
		if (paperContentInfo.value.analysisVideo !== null && paperContentInfo.value.analysisVideo !== "") {
			// await getVideo(paperContentInfo.value.analysisVideo);
			videoDetailPath.value = 'view' + analysisVideoPath + paperContentInfo.value.analysisVideo;
		}
		if (paperContentInfo.value.referenceVideo !== null && paperContentInfo.value.referenceVideo !== "") {
			// await getVideo(paperContentInfo.value.referenceVideo);
			referenceVideoDetailPath.value = 'view' + analysisVideoPath + paperContentInfo.value.referenceVideo;
		}
    recognizeCount.value = (paperContentInfo.value?.questionRecognizeDtoList || []).filter(item => item
        .answer).length;
	}

	function getPaperContentByRandomExam(questionType, status) {
		request.get('/paperContentInfo/randomExam/one', {
				params: {
					userId: loginUserId,
					questionType: questionType,
					type: status,
					questionNumber: questionNumber.value,
					subjectId: this.paperInfo.subjectId
				}
			})
			.then(response => {
				const result = response.data; // 将接口返回的数据赋值给result
				if (result.code === "200") {
					paperContentInfo.value = result.data;
					getRelativeInfo('randomExam');
				} else {
					ElMessage.warning(result.msg);
				}
			})
			.catch(error => {
				console.log("TheoryMediumDevice error:" + error);
				// ElMessage.error("系统异常，请联系管理员");
			});
	}

	function getPaperContentByLabel(questionType, status) {
		request.get('/paperContentInfo/label/subjectId/one', {
				params: {
					userId: loginUserId,
					label: questionType,
					type: status,
					questionNumber: questionNumber.value,
					subjectId: this.paperInfo.subjectId
				}
			})
			.then(response => {
				const result = response.data; // 将接口返回的数据赋值给result
				if (result.code === "200") {
					paperContentInfo.value = result.data;
					getRelativeInfo("label")
				} else {
					ElMessage.warning(result.msg);
				}
			})
			.catch(error => {
				console.log("TheoryMediumDevice error:" + error);
				// ElMessage.error("系统异常，请联系管理员");
			});
	}

	function getOperationInfo(questionId, stepId) {
		request.get('/questionOperationInfo/questionId/step', {
				params: {
					userId: loginUserId,
					questionId: questionId,
					stepId: stepId
				}
			})
			.then(response => {
				const result = response.data; // 将接口返回的数据赋值给result
				if (result.code === "200") {
					this.paperContentInfo.questionOperationDtoList = result.data;
				} else {
					ElMessage.warning(result.msg);
					// router.push("/login");
				}
			})
			.catch(error => {
				console.log("TheoryMediumDevice error:" + error);
				// ElMessage.error("系统异常，请联系管理员");
			});
	}

	function getPreModifyInfo(questionId, stepId) {
		request.get('/questionPreModifyInfo/questionId/step', {
				params: {
					userId: loginUserId,
					questionId: questionId,
					stepId: stepId
				}
			})
			.then(response => {
				const result = response.data; // 将接口返回的数据赋值给result
				if (result.code === "200") {
					this.paperContentInfo.questionPreModifyDtoList = result.data;
				} else {
					ElMessage.warning(result.msg);
					// router.push("/login");
				}
			})
			.catch(error => {
				console.log("TheoryMediumDevice error:" + error);
				// ElMessage.error("系统异常，请联系管理员");
			});
	}

	function getUserAuthorization(paperId) {
		request.get('/userAuthorization/check', {
				params: {
					userId: loginUserId,
					paperId: paperId,
					type: "subject"
				}
			})
			.then(response => {
				const result = response.data; // 将接口返回的数据赋值给result
				if (result.code === "200") {
					isBuy.value = result.data.checked;
				} else {
					ElMessage.warning(result.msg);
					router.push("/buyPage");
				}
			})
			.catch(error => {
				console.log("TheoryMediumDevice error:" + error);
				ElMessage.error("请重新登录");
				router.push("/login");
			});
	}

	async function getPaperContentInfo(paperId, questionNumberId, paperType) {
		await request.get('/paperContentInfo/one', {
				params: {
					userId: loginUserId,
					paperId: paperId,
					questionNumber: questionNumberId,
					paperType: paperType
				}
			})
			.then(response => {
				const result = response.data; // 将接口返回的数据赋值给result
				if (result.code === "200") {
					paperContentInfo.value = result.data;
					getRelativeInfo("active");
				} else {
					ElMessage.warning(result.msg);
				}
			})
			.catch(error => {
				console.log("TheoryMediumDevice error:" + error);
				// ElMessage.error("系统异常，请联系管理员");
			});
	}

	async function getPaperInfo(paperId) {
		await request.get('/paperInfo/paperId', {
				params: {
					userId: loginUserId,
					paperId: paperId
				}
			})
			.then(response => {
				const result = response.data; // 将接口返回的数据赋值给result
				if (result.code === "200") {
					this.paperInfo = result.data;
				} else {
					ElMessage.warning(result.msg);
				}
			})
			.catch(error => {
				console.log("TheoryMediumDevice error:" + error);
				// ElMessage.error("系统异常，请联系管理员");
			});
	}

	async function getPaperDetailInfo(paperId, paperType) {
		await request.get('/paperDetailInfo/type', {
				params: {
					userId: loginUserId,
					paperId: paperId,
					paperType: paperType
				}
			})
			.then(response => {
				const result = response.data; // 将接口返回的数据赋值给result
				if (result.code === "200") {
					this.paperDetailInfo = result.data;
					paperTotalCount.value = this.paperDetailInfo.totalCount;
				} else {
					ElMessage.warning(result.msg);
				}
			})
			.catch(error => {
				console.log("paperDetailInfo error:" + error);
				// ElMessage.error("系统异常，请联系管理员");
			});
	}

	async function uploadRecord() {
		const formData = new FormData();
		formData.append("file", this.recBlob, Date.now() + ".mp3");
		formData.append("userId", loginUserId);
		formData.append("paperId", paperId.value);
		formData.append("questionId", paperContentInfo.value.id);
		formData.append("areaId", areaId.value);
		formData.append("questionNumber", questionNumber.value);
		formData.append("examId", "");

		await request.post('/paperContentQuestionInfo/oral', formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		}).then(response => {
			const result = response.data; // 将接口返回的数据赋值给result
			if (result.code === "200") {
				this.oralStatus = "recognizing";
			} else {
				ElMessage.warning(result.msg);
			}
		}).catch(error => {
			console.log("uploadRecord error:" + error);
			// ElMessage.error("系统异常，请联系管理员");
		});
	}

	async function uploadNewQuestionRecord() {
		const formData = new FormData();
		formData.append("file", this.recBlob, Date.now() + ".mp3");
		formData.append("userId", loginUserId);
		// formData.append("paperId",paperId);
		formData.append("id", paperContentInfo.value.id);

		await request.post('/userQuestionInfo/oral', formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		}).then(response => {
			const result = response.data; // 将接口返回的数据赋值给result
			if (result.code === "200") {
				this.oralStatus = "recognizing";
			} else {
				ElMessage.warning(result.msg);
			}
		}).catch(error => {
			console.log("uploadNewQuestionRecord error:" + error);
			// ElMessage.error("系统异常，请联系管理员");
		});
	}


	function getPaperDetailInfoByExamId(examId) {
		request.get('/userQuestionInfo/paperDetail/exam', {
				params: {
					userId: loginUserId,
					examId: examId
				}
			})
			.then(response => {
				const result = response.data; // 将接口返回的数据赋值给result
				if (result.code === "200") {
					this.paperDetailInfo = result.data;
					paperTotalCount.value = this.paperDetailInfo.totalCount;
					if (paperTotalCount.value === 0) {
						ElMessage.success("")
					}
				} else {
					ElMessage.warning(result.msg);
				}
			})
			.catch(error => {
				console.log("TheoryMediumDevice error:" + error);
				// ElMessage.error("系统异常，请联系管理员");
			});
	}


	function getPaperContentByExamId(examId) {
		request.get('/userQuestionInfo/paperContentInfo/exam', {
				params: {
					userId: loginUserId,
					examId: examId,
					questionNumber: questionNumber.value,
				}
			})
			.then(response => {
				const result = response.data; // 将接口返回的数据赋值给result
				if (result.code === "200") {
					paperContentInfo.value = result.data;
					getRelativeInfo("exam")
				} else {
					ElMessage.warning(result.msg);
				}
			})
			.catch(error => {
				console.log("TheoryMediumDevice error:" + error);
				// ElMessage.error("系统异常，请联系管理员");
			});
	}

	function deleteSelfAnswer() {
		request.delete('/userQuestionInfo/userAnswer', {
				data: {
					userId: loginUserId,
					paperId: paperId.value,
					subjectId: this.paperInfo.subjectId,
					questionId: questionId.value,
					type: "userDefineAnswer",
					questionType: questionType.value,
				}
			})
			.then(response => {
				const result = response.data; // 将接口返回的数据赋值给result
				if (result.code === "200") {
					ElMessage.success("删除成功");
					showSelfAnswer.value = false;
					hasSelfAnswer.value = false;
				} else {
					ElMessage.warning(result.msg);
				}
			})
			.catch(error => {
				console.log("TheoryMediumDevice error:" + error);
				// ElMessage.error("系统异常，请联系管理员");
			});
	}

	function updateSelfAnswer() {
		request.put('/userQuestionInfo/userAnswer', {
				userId: loginUserId,
				paperId: paperId.value,
				subjectId: this.paperInfo.subjectId,
				questionId: questionId.value,
				type: "userDefineAnswer",
				questionType: questionType.value,
				answerText: userDefineAnswerContent.value,
				answerAudio: userDefineAudio.value,
			})
			.then(response => {
				const result = response.data; // 将接口返回的数据赋值给result
				if (result.code === "200") {
					if (result.data !== null) {
						ElMessage.success("修改成功");
						showSelfAnswer.value = false;
						hasSelfAnswer.value = true;
						userQuestionInfo.value = result.data;
					}
				} else {
					ElMessage.warning(result.msg);
				}
			})
			.catch(error => {
				console.log("TheoryMediumDevice error:" + error);
				// ElMessage.error("系统异常，请联系管理员");
			});
	}

	function getUserSelfDefineAnswer() {
		request.post('/userQuestionInfo/question', {
				userId: loginUserId,
				paperId: paperId.value,
				subjectId: this.paperInfo.subjectId,
				questionId: questionId.value,
				type: "userDefineAnswer",
				questionType: questionType.value

			})
			.then(response => {
				const result = response.data; // 将接口返回的数据赋值给result
				if (result.code === "200") {
					if (result.data.id !== null) {
						showSelfAnswer.value = false;
						hasSelfAnswer.value = true;
						userQuestionInfo.value = result.data;
						userDefinePlayerUrl.value = 'view' + userQuestionInfo.value.answerAudio;
					}
				} else {
					ElMessage.warning(result.msg);
				}
			})
			.catch(error => {
				console.log("TheoryMediumDevice error:" + error);
				// ElMessage.error("系统异常，请联系管理员");
			});
	}

	function getUserOralAnswer() {
		request.get('/userOralAnswer/getInfo', {
				params: {
					userId: loginUserId,
					type: 'oral',
					paperId: paperId.value
				}
			}).then(response => {
				const result = response.data; // 将接口返回的数据赋值给result
				if (result.code === "200") {
					userOralAnswer.value = result.data;
					isCountScore.value = true;
				} else {
					ElMessage.warning(result.msg);
				}
			})
			.catch(error => {
				console.log("getUserOralAnswer error:" + error);
				// ElMessage.error("系统异常，请联系管理员");
			});
	}

	function submitSelfAnswer() {
		request.post(
				'/userQuestionInfo/', {
					"userId": loginUserId,
					"questionId": questionId.value,
					"questionType": questionType.value,
					"type": "userDefineAnswer",
					"answerText": userDefineAnswerContent.value,
					"answerAudio": userDefineAudio.value,
					"paperId": paperId.value,
					"subjectId": this.paperInfo.subjectId
				}, {
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					}
				})
			.then(response => {
				const result = response.data; // 将接口返回的数据赋值给result
				if (result.code !== "200" && result.msg !== "") {
					ElMessage.error(result.msg);
				} else {
					ElMessage.success("自定义答案提交成功!");
					getUserSelfDefineAnswer.call(this);
				}
			}).catch(error => {
				console.error("sendPhoneConfirmCode error:" + error);
				// ElMessage.info("系统异常，请联系管理员");
			});
	}
	const chooseAnswerInfo = ref({
		questionId: '',
		answer: false,
		alphabet: '',
		correctAnswerAlphabet: ''
	});

	const selectedAnswers = ref([]);
	const selectedQuestions = ref([]);
	const showAnalysis = ref(false);

	const selectedRecognizeItem = ref([]);
	const selectedOperationItem = ref(null);


	const questionAudioPlayer = ref(new Audio());
	const questionTypePlayer = ref(new Audio());

	const showGif = ref(true);


	// const preModifyAudioPlayer = ref(null);
	// const preModifySoundPath=ref('');

	const paperContentInfo = ref('');

	const operationAudioPlayer = ref(new Audio());
	// const operationSoundPath=ref('');
	const isRecording = ref(false);
	const hasRecord = ref(false);
	const recordPlayer = ref(new Audio());
	const recordUrl = ref('');

	const answerPlayer = ref(new Audio());
	const showFeedBack = ref(false);
	const areaId = ref('');
	const paperId = ref('');
	const questionId = ref(0);
	const examId = ref('');
	const showSelfAnswer = ref(false);
	const userDefineAnswerContent = ref('');
	const hasSelfAnswer = ref(false);
	const userQuestionInfo = ref('');
	// const currentVolume = ref(0);
	const videoDetailPath = ref('');
	const referenceVideoDetailPath = ref('');
	const userOralAnswer = ref('');
  const recognizeCount = ref(0);

	export default {
		name: "PeoplePaperPractice",
		components: {
			QuestionFilled,
			feedBackComponent,
			recordComponent
		},
		data() {
			return {
				loginNickName: loginNickName,
				paperInfo: '',
				paperDetailInfo: '',
				paperContentInfo: paperContentInfo,
				userAnswer: '',
				selectedAnswers: selectedAnswers,
				chooseAnswerInfo: chooseAnswerInfo,
				// hasSelected: hasSelected,
				questionNumber: questionNumber,
				percentage: percentage,
				isBuy: isBuy,
				backgroundImg: backgroundImg,
				showAnalysis: showAnalysis,
				selectedRecognizeItem: selectedRecognizeItem,
				paperFontSize: paperFontSize,
				currentStepId: currentStepId,
				totalStepCount: totalStepCount,
				selectedOperationItem: selectedOperationItem,
				// soundPath:soundPath,
				questionAudioPlayer: questionAudioPlayer,
				showGif: showGif,
				isRecording: isRecording,
				hasRecord: hasRecord,
				recordPlayer: recordPlayer,
				recordUrl: recordUrl,
				recBlob: "",
				oralStatus: "init",
				answerPlayer: answerPlayer,
				showFeedBack: showFeedBack,
				paperId: paperId,
				areaId: areaId,
				questionId: questionId,
				questionType: questionType,
				examId: examId,
				showSelfAnswer: showSelfAnswer,
				userDefineAnswerContent: userDefineAnswerContent,
				hasSelfAnswer: hasSelfAnswer,
				userQuestionInfo: userQuestionInfo,
				userDefinePlayerUrl: userDefinePlayerUrl,
				userDefineAudio: userDefineAudio,
				showAnswerRecord: showAnswerRecord,
				hasUserDefineRecord: hasUserDefineRecord,
				videoDetailPath: videoDetailPath,
				referenceVideoDetailPath: referenceVideoDetailPath,
				// mediaRecorder:new Recorder(),
				isCountScore: isCountScore,
				userOralAnswer: userOralAnswer
			}
		},
		async created() {
			const route = useRoute()
			areaId.value = route.query.areaId
			paperId.value = route.query.paperId
			questionNumber.value = parseInt(route.query.questionNumber, 10);
			examId.value = route.query.examId;
			if (examId.value != null) {
				getPaperDetailInfoByExamId.call(this, examId.value);
				await getPaperContentByExamId.call(this, examId.value);
				this.getUserAuthorization(paperId.value);
				this.userAnswer = null;
				selectedAnswers.value = [];
				return;
			}
			this.getUserAuthorization(route.query.paperId);
			await this.getPaperInfo(route.query.paperId);

			if (this.paperInfo.status === 'active') {
				await this.getPaperDetailInfo(route.query.paperId, route.query.questionType);
				await this.getPaperContentInfo(route.query.paperId, route.query.questionType);
			}
			if (this.paperInfo.status === 'error' || this.paperInfo.status === 'userDefine') {
				getPaperDetailInfoByQuestionId.call(this, route.query.questionType, this.paperInfo.status)
				getPaperContentByUserQuestion.call(this, route.query.questionType, this.paperInfo.status)
			}

			if (this.paperInfo.status === 'feedBack') {
				await getPaperDetailInfoByFeedBack.call(this, route.query.questionType)
				await getPaperContentByFeedBack.call(this, route.query.questionType)
			}

			if (this.paperInfo.status === 'randomExam') {
				getPaperDetailInfoByRandomExam.call(this, route.query.questionType, this.paperInfo.status)
				getPaperContentByRandomExam.call(this, route.query.questionType, this.paperInfo.status)
			}

			if (this.paperInfo.status === 'label') {
				await this.getPaperDetailInfo(route.query.paperId, route.query.questionType);
				getPaperContentByLabel.call(this, route.query.questionType, this.paperInfo.status)
			}
			questionType.value = route.query.questionType;

			this.userAnswer = null;
			selectedAnswers.value = [];
			// getUserSelfDefineAnswer.call(this);
		},
		methods: {
			handleToPage(path) {
				router.push(path);
			},
			handleToTryPractice(trainPath, buyMode, studyMode, subjectType) {
				router.push({
					path: trainPath,
					query: {
						areaId: areaId.value,
						studyMode: studyMode,
						buyMode: buyMode,
						subjectType: subjectType
					}
				});
			},
			getUserAuthorization(paperId) {
				getUserAuthorization.call(this, paperId)
			},
			async getPaperInfo(paperId) {
				await getPaperInfo.call(this, paperId);
			},
			async getPaperDetailInfo(paperId, questionType) {
				await getPaperDetailInfo.call(this, paperId, questionType);
			},
			async getPaperContentInfo(paperId, questionType) {
				await getPaperContentInfo.call(this, paperId, questionNumber.value, questionType)
			},
			getCurrentChoice(answerInfo) {
				chooseAnswerInfo.value = answerInfo;
				const selectedQuestion = selectedQuestions.value.find(item => item.questionNumber === questionNumber
					.value);
				if (selectedQuestion) {
					selectedQuestion.isCorrect = answerInfo.answer;
					selectedQuestion.answerInfos = [answerInfo];
				} else {
					selectedQuestions.value.push({
						"questionNumber": questionNumber.value,
						"isCorrect": answerInfo.answer,
						"answerInfos": [answerInfo]
					});
				}
				percentage.value = Math.floor((selectedQuestions.value.length / paperTotalCount.value) * 100);
			},
			getPreviousQuestion() {
				questionNumber.value = questionNumber.value - 1;
				this.getPaperContentInfoByStatus();
			},
			getNextQuestion() {
				questionNumber.value = questionNumber.value + 1;
				this.getPaperContentInfoByStatus();
			},
			getCurrentQuestion() {
				this.getPaperContentInfoByStatus();
			},
			getPaperContentInfoByStatus() {
				this.userAnswer = null;
				this.selectedAnswers.value = [];
				chooseAnswerInfo.value = {
					questionId: '',
					answer: false,
					alphabet: '',
					correctAnswerAlphabet: ''
				};
				// hasSelected.value = false;
				selectedRecognizeItem.value = [];
				selectedOperationItem.value = [];
				currentStepId.value = 1;
				totalStepCount.value = 1;
				videoDetailPath.value = "";
				referenceVideoDetailPath.value = "";
				if (examId.value != null) {
					return getPaperContentByExamId.call(this, examId.value);
				}
				if (this.paperInfo.status === 'active') {
					getPaperContentInfo.call(this, this.paperInfo.id, questionNumber.value, questionType.value);
				}
				if (this.paperInfo.status === 'userDefine') {
					getPaperContentByUserQuestion.call(this, questionType.value, this.paperInfo.status)
				}
				if (this.paperInfo.status === 'randomExam') {
					getPaperContentByRandomExam.call(this, questionType.value, this.paperInfo.status)
				}
				if (this.paperInfo.status === 'label') {
					getPaperContentByLabel.call(this, questionType.value, this.paperInfo.status)
				}
			},
			checkAnswerIsCorrect() {
				if (questionType.value === 'recognize' || questionType.value === 'judgment') {
					return chooseAnswerInfo.value.answer;
				}
				if (!chooseAnswerInfo.value.answer) {
					return false
				}
				let correctAnswerString = chooseAnswerInfo.value.correctAnswerAlphabet.toString().replaceAll(",", "")
				if (selectedAnswers.value.length > correctAnswerString.length) {
					return false;
				}
				if (selectedAnswers.value.length === correctAnswerString.length) {
					return selectedAnswers.value.every((element) => element.answer === true);
				}
				return false;
			},
			getAnalysis() {
				getUserSelfDefineAnswer.call(this);
				showAnalysis.value = true;
			},
      selectMultiBoxAsAnswer(item) {
        if (selectedRecognizeItem.value.length < recognizeCount.value) {
          selectedRecognizeItem.value.push(item);
        } else {
          selectedRecognizeItem.value.splice(0, 1);
          selectedRecognizeItem.value.push(item);
        }
        currentStepId.value = 2;
      },
			submitAnswer() {
				let answerResult = true;
				let hasSelectAnswer = false;
        if ((selectedRecognizeItem.value || [])?.length > 0) {
          hasSelectAnswer = true;
          let selectRecognizeAnswerCount = selectedRecognizeItem.value.filter(item => item.answer)
              .length;
          if (selectRecognizeAnswerCount !== recognizeCount.value) {
            answerResult = false;
          }
        }
        if (selectedOperationItem.value !== null && selectedOperationItem.value !== undefined && Object.keys(
            selectedOperationItem.value).length > 0) {
          hasSelectAnswer = true;
          if (!selectedOperationItem.value.answer) {
            answerResult = false;
          }
        }
				if (chooseAnswerInfo.value.questionId !== '') {
					hasSelectAnswer = true;
					if (!chooseAnswerInfo.value.answer) {
						answerResult = false;
					}
				}

				if (hasSelectAnswer === false) {
					ElMessage.error("请选择答案")
					return;
				}
				if (answerResult === true) {
					answerPlayer.value.src = require("@/assets/sound/correct.mp3");
					answerPlayer.value.play()
					if (questionNumber.value === paperTotalCount.value) {
						ElMessageBox.alert('回答正确,最后一题答题完成', '', {
								// confirmButtonText: '确定',
								type: "success",
								center: true,
							}


						);
						setTimeout(() => {
							this.$msgbox.close();
							this.goBack();
						}, 2000);

					} else {
						ElMessageBox.alert('回答正确', '', {
							// confirmButtonText: '确定',
							type: "success",
							showConfirmButton: false,
							showClose: false,
							center: true,
						});

						setTimeout(() => {
							this.$msgbox.close();
							this.getNextQuestion();
						}, 2000);
					}
				} else {
					answerPlayer.value.src = require("@/assets/sound/error.mp3");
					answerPlayer.value.play()

					ElMessageBox.alert('回答错误', '', {
						type: "error",
						confirmButtonText: '查看解析',
						center: true,
						callback: () => {
							this.getAnalysis();
						}
					})
					setTimeout(() => {
						this.$msgbox.close();
						this.getCurrentQuestion();
					}, 2000);
				}
			},
      handleRightClick(event,operationItem){
        console.log("rightClick");
        event.preventDefault();
        showGif.value = true;
        console.log(operationItem.methodName);
        this.operationClick(operationItem);
      },
			operationClick(operationItem) {
				showGif.value = true;
        if (operationItem.methodName === 'playAudio') {
          operationAudioPlayer.value.src = require(`@/assets/sound${operationItem.imagePath}`);
          operationAudioPlayer.value.play();
          this.switchoverPreModify(operationItem);
        }
        if (operationItem.methodName === 'switchoverPreModify') {
          operationAudioPlayer.value.pause();
          this.switchoverPreModify(operationItem)
        }

			},
			switchoverPreModify(operationItem) {
				if (currentStepId.value !== operationItem.nextStepId) {
					getPreModifyInfo.call(this, operationItem.questionId, operationItem.nextStepId);
					if (operationItem.nextStepId < totalStepCount.value) {
						getOperationInfo.call(this, operationItem.questionId, operationItem.nextStepId);
					}
					currentStepId.value = operationItem.nextStepId;
				}
				selectedOperationItem.value = operationItem;
			},
			playQuestionAudio() {
				if (questionAudioPlayer.value != null) {
					questionAudioPlayer.value.play();
				}
			},
			goBack() {
				if (isBuy.value) {
					this.handleToTryPractice('/fire/normal/practice/peopleMediumDevice', 'normal', 'practice', 'people');
				} else {
					this.handleToTryPractice('/fire/try/practice/peopleMediumDevice', 'try', 'practice', 'people');
				}
			},
			closeGif() {
				setTimeout(()=>{
          showGif.value = false;
        }, 10000);
			},

			startRecording() {
				isRecording.value = true;
			},

			async submitRecording(value) {
				isRecording.value = false;
				if (value != null) {
					this.recBlob = value;
					if (this.paperInfo.status === 'active') {
						await uploadRecord.call(this);
					}
					if (this.paperInfo.status === 'userDefine') {
						await uploadNewQuestionRecord.call(this);
					}
					if (this.oralStatus === 'recognizing') {
						if (questionNumber.value === paperTotalCount.value) {
							ElMessage.success("已加入计分序列，稍后显示得分,此为最后一题");
						} else {
							ElMessage.success("已加入计分序列，稍后显示得分，请继续答题");
							this.getNextQuestion();
						}
					}
				}

			},
			async showCounting() {
				await getUserOralAnswer.call(this);
			},
			feedBack() {
				showFeedBack.value = true;
			},
			handleFeedBackDialog(value) {
				if (value === 'success') {
					showFeedBack.value = false;
				}
			},
			defineSelfAnswer() {
				showSelfAnswer.value = true;
			},
			submitSelfAnswer() {
				if (userDefineAnswerContent.value === '') {
					ElMessage.warning("请输入自定义答案");
					return;
				}
				if (hasSelfAnswer.value) {
					updateSelfAnswer.call(this);
					return;
				}
				submitSelfAnswer.call(this);
				getUserSelfDefineAnswer.call(this);
				showSelfAnswer.value = false;
			},
			modifySelfAnswer() {
				showSelfAnswer.value = true;
			},
			deleteSelfAnswer() {
				this.$confirm("确定删除?",
					'', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning',
					}).then(async () => {
					deleteSelfAnswer.call(this)
				});
			},
			userDefinePlay() {
				userDefinePlayer.value.play();
			},
			userDefinePlayerPause() {
				userDefinePlayer.value.pause();
			},
			userDefineText2Audio() {
				if (userDefineAnswerContent.value == null || userDefineAnswerContent.value === '') {
					return ElMessage.error("请输入自定义答案");
				}
				text2AudioAnswer.call(this);
				hasUserDefineRecord.value = true;
			},
			removeUserDefineAudio() {
				if (userDefineAudio.value === "") {
					userDefineAudio.value = '';
					return ElMessage.info("删除成功");
				}
				this.$confirm(`确定移除 ${userDefineAudio.value.slice(-8)}？`).then(() => {
					deleteAudioFromServer.call(this, userDefineAudio.value, "answer");
					hasUserDefineRecord.value = false;
				})
			},
			userDefineAnswerAudio() {
				showAnswerRecord.value = true;
			},
			handleAnswerRecordDialog(value) {
				if (value != null) {
					uploadUserDefineRecord.call(this, value, "answer");
					userDefinePlayerUrl.value = URL.createObjectURL(value);
					showAnswerRecord.value = false;
					hasUserDefineRecord.value = true;
				}
			},

			beforeUserDefineAudioUpload(file) {
				if (file.type !== "audio/mpeg") {
					ElMessage.error("音频文件必须是.mp3格式！");
					return false;
				} else if (file.size / 1024 / 1024 > 5) {
					ElMessage.error("文件过大！");
					return false;
				}
				return true;
			},

			uploadUserDefineAudio(file) {
				if (file != null) {
					uploadUserDefineRecord.call(this, file.file, "answer");
					userDefinePlayerUrl.value = URL.createObjectURL(file.file);
					hasUserDefineRecord.value = true;
				}
			},
			getAnalysisPath(path) {
				videoDetailPath.value = analysisVideoPath + path;
			},
			reAnswer(row) {
				console.log(row);
				isCountScore.value = false;
				router.push({
					path: "/fire/peoplePaperPractice",
					query: {
						areaId: areaId.value,
						paperId: paperId.value,
						questionType: questionType.value,
						questionNumber: row.questionNumber,
						// date: new Date().getTime(),
					}
				}).then(() => {
					location.reload();
				});
				// if(isBuy.value){
				//   this.handleToTryPractice('/fire/normal/practice/peopleMediumDevice','normal', 'practice','people');
				// }
				// else {
				//   this.handleToTryPractice('/fire/try/practice/peopleMediumDevice','try', 'practice','people');
				// }
			}
		}
	}
</script>
<style scoped>
	.mode-col {
		height: 300px;
		width: 400px;
		/* 设置一个高度让背景显示出来 */
		background-size: contain;
		background-repeat: no-repeat;
		/* 背景图片覆盖整个元素 */
		transition: background-image 0.5s;
		/* 可选的，背景图变化过渡效果 */
		/*align-content: center;*/
		/*background-color: lightgray;*/
	}

	.room-div {
		/*background-image: v-bind(backgroundImg);*/
		background-size: cover;
		background-repeat: no-repeat;
		height: 810px;
		width: 1350px;
		position: absolute;
	}

	.el-menu {
		background-color: transparent;
		border-bottom-color: transparent;
	}

	.el-menu-item {
		background-color: transparent !important;
		color: black !important;
		font-weight: 50;
		width: 200px;
		font-size: 18px;
		text-align: center;

		&:not(.is-disabled):hover {
			color: gray !important;
			background-color: lightgray !important;
			width: 200px;
			text-align: center;
		}
	}

	.content {
		flex: 1;
		/* 让内部容器充满剩余空间 */
		display: flex;
		/*align-items: center; !* 垂直居中 *!*/
		justify-content: flex-start;
		/* 水平方向从左边开始排列 */
	}

	.el-radio :deep(.el-radio__label) {
		font-size: v-bind(paperFontSize);
		line-height: 2;
		color: black;
		/*margin-right: 15px;*/
		white-space: normal;
		word-break: break-all;
	}

	.el-radio :deep(.el-radio__inner) {
		width: v-bind(paperFontSize);
		height: v-bind(paperFontSize);
		border-color: black;
	}

	.el-radio :deep(.el-radio__input.is-checked + .el-radio__label) {
		color: black;
	}

	.el-radio :deep(.el-radio__input.is-checked .el-radio__inner) {
		border-color: blue;
		/* 选中边框的颜色 */
		background-color: blue;
		/* 选中背景的颜色 */
	}

	.el-checkbox :deep(.el-checkbox__label) {
		font-size: v-bind(paperFontSize);
		/* 这里设置你想要的字体大小 */
		overflow: hidden;
		white-space: normal;
		word-break: break-all;
		color: black;
	}

	.el-checkbox :deep(.el-checkbox__input.is-checked + .el-checkbox__label) {
		color: black;
		/* 替换为你想要的颜色 */
	}

	.el-checkbox :deep(.el-checkbox__inner) {
		width: 16px;
		/* 修改选框的宽度 */
		height: 16px;
		/* 修改选框的高度 */
		border-color: black;
	}

	.el-checkbox :deep(.el-checkbox__input.is-checked .el-checkbox__inner),
	.el-checkbox :deep(.el-checkbox__input.is-indeterminate .el-checkbox__inner) {
		background-color: black;
		/* 你想要的选中颜色 */
		border-color: black;
	}

	/* 修改选中时的对勾颜色 */
	.el-checkbox :deep(.el-checkbox__input.is-checked .el-checkbox__inner::after) {
		color: black;
		/* 对勾颜色 */
	}

	.draggable {
		position: relative;
		margin-top: 25px;
		width: 250px;
		/*height: 10%;*/
		cursor: pointer;
		background-color: rgb(255, 180, 17);
		color: black;
		border: 1px solid rgb(255, 180, 17);
		text-align: left;
		border-radius: 10px;
		/* 设置圆角的半径 */
		font-size: v-bind(paperFontSize);

		/*line-height: 100px;*/
		/*z-index: 10;*/
	}

	/*.draggable:hover {*/
	/*  transform: translate(20px, 20px);*/
	/*}*/

	.div-recognize-bordered-item {
		position: absolute;
		border: 3px solid rgb(17, 163, 17);
		box-shadow: inset 0 0 10px #4dff00, 0 0 10px #4dff00db;
		padding: 10px;
		margin: 0;
		cursor: default;
    box-sizing: border-box;
	}

	.div-recognize-selected {
		/*border-color: lightgreen;*/
		background-color: #00ff0075;
	}

	.div-pre-modify-bordered-item {
		position: absolute;
		padding: 10px;
		margin: 5px;
		cursor: default;
		transition: opacity 1s;
	}

	.div-operation-bordered-item {
		position: absolute;
		padding: 10px;
		margin: 5px;
		cursor: default;
	}

	.el-card-class {
		width: 96%;
	}

  .dialogBody{
    white-space: pre-wrap;
  }
	/*.volume {*/
	/*  text-align: center;*/
	/*  font-size: 12px;*/
	/*}*/
	/*.volume-span {*/
	/*  display: inline-block;*/
	/*  margin-left: 2px;*/
	/*  width: 4px;*/
	/*  height: 20px;*/
	/*  background: #c6e2ff;*/
	/*}*/
</style>
